<!-- src/components/AvatarInitials.vue -->
<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  name?: string
  size?: number
}>()

const initials = computed(() => {
  const n = (props.name || 'User Account').trim().split(/\s+/)
  const i = (n[0]?.[0] || '') + (n[1]?.[0] || '')
  return i.toUpperCase()
})
</script>

<template>
  <div
    class="rounded-circle inline-flex items-center justify-center"
    :style="{
      width: (size || 32) + 'px',
      height: (size || 32) + 'px',
      background: '#E0E0E0',
      fontWeight: 600,
      fontSize: (size || 32) * 0.45 + 'px',
      color: '#424242',
      userSelect: 'none',
    }"
    aria-label="avatar-initials"
  >
    {{ initials }}
  </div>
</template>
